import { Sparkles, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import TextButton from "@/shared/components/ui/Button/TextButton";

/** One small, non-blocking card for a big launch: shown once, dismissed for good. */
export default function WhatsNewSpotlight({ update, leftOffset, onDismiss, onSeeAll }) {
  const navigate = useNavigate();
  if (!update) return null;
  return (
    <aside
      role="status"
      aria-label="New in SalesWorx"
      style={{ "--spotlight-left": `${leftOffset}px` }}
      className="fixed bottom-[calc(4.5rem+env(safe-area-inset-bottom))] left-4 right-4 z-[9990] flex flex-col gap-2 rounded-2xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 shadow-xl sm:right-auto sm:w-[340px] md:bottom-6 md:left-[var(--spotlight-left)]"
    >
      <div className="flex items-center gap-2 text-xs font-medium text-secondary">
        <Sparkles size={14} />
        <span>New in SalesWorx</span>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="ml-auto rounded-full p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-gray-200"
        >
          <X size={16} />
        </button>
      </div>
      <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{update.title}</p>
      <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">{update.body}</p>
      <div className="mt-1 flex items-center justify-between gap-2">
        <TextButton onClick={onSeeAll} className="-ml-1.5">See all updates</TextButton>
        {update.cta?.to && (
          <PrimaryButton
            startContent={false}
            onClick={() => {
              onDismiss();
              navigate(update.cta.to);
            }}
          >
            {update.cta.label || "Try it"}
          </PrimaryButton>
        )}
      </div>
    </aside>
  );
}
